export var IdOrientation;
(function (IdOrientation) {
    IdOrientation["Left"] = "left";
    IdOrientation["Right"] = "right";
    IdOrientation["Down"] = "down";
    IdOrientation["Up"] = "up";
})(IdOrientation || (IdOrientation = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdOrientation.ts
// module id = 78
// module chunks = 3